export default "__VITE_ASSET__053d226f__"